// Spreads edges that share the same source/target node vertically apart so
// their lines don't overlap on the canvas.

const SLOT_HEIGHT = 39;
const SLOT_START_OFFSET = 21;

export function computeEdgeOffsets(edges) {
    const countsFrom = {};
    const countsTo = {};
    const offsets = {};

    for (const edge of edges) {
        countsFrom[edge.from] ??= 0;
        countsTo[edge.to] ??= 0;

        offsets[edge.id] = {
            fromOffset: countsFrom[edge.from] * SLOT_HEIGHT + SLOT_START_OFFSET,
            toOffset: countsTo[edge.to] * SLOT_HEIGHT + SLOT_START_OFFSET,
        };

        countsFrom[edge.from]++;
        countsTo[edge.to]++;
    }

    return offsets;
}
